var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/system';
import { AnimatedCircles } from 'hx-ui/src/components/Circles/AnimatedCircles/AnimatedCircles';
import { useState } from 'react';
import { palette } from '@/theme/palette';
import { SideImageLayout } from 'hx-ui';
import { cn } from 'hx-util';
import { useNavigate } from 'react-router-dom';
import { GradientDivider } from '@/components/gradient-divider.component';
export function InstructionsStep() {
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.up('md'));
    return (_jsx(SideImageLayout, { header: !isMobile ? _jsx(Instructions, { className: 'p-6 pb-0' }) : null, classNames: { content: 'md:col-span-2', imageLeft: 'md:col-span-1' }, className: 'md:grid-cols-3 overflow-y-auto', leftPanel: _jsx(Instructions, {}), content: _jsx(MainContent, {}) }));
}
function Instructions(_a) {
    var className = _a.className;
    return (_jsxs("div", __assign({ className: cn('flex flex-col justify-center items-center md:gap-16 gap-6 h-full md:bg-faux-black md:p-10 w-full', className) }, { children: [_jsx(Typography, __assign({ className: 'font-extrabold text-3xl md:text-4xl md:text-white' }, { children: "Hearing test instructions" })), _jsx(GradientDivider, { className: 'w-full md:hidden' }), _jsxs("div", __assign({ className: 'flex flex-col gap-4' }, { children: [_jsxs(Typography, __assign({ className: 'md:text-xl text-lg md:text-white' }, { children: ["We will play ", _jsx("strong", { children: "3 numbers" }), " with background noise."] })), _jsxs(Typography, __assign({ className: 'md:text-xl text-lg md:text-white' }, { children: ["Enter the numbers you hear in the order you hear them and press", ' ', _jsx("strong", { children: "SUBMIT." })] })), _jsxs(Typography, __assign({ className: 'md:text-xl text-lg md:text-white' }, { children: ["If you can't hear the numbers clearly, enter your", ' ', _jsx("strong", { children: "best guess." })] }))] }))] })));
}
function MainContent() {
    var _a = useState('Start'), buttonText = _a[0], setButtonText = _a[1];
    var navigate = useNavigate();
    function onClick() {
        if (buttonText !== 'Start')
            return;
        var currentCount = 3;
        setButtonText("".concat(currentCount));
        var timerId = setInterval(function () {
            currentCount--;
            if (currentCount > 0) {
                setButtonText("".concat(currentCount));
            }
            else {
                clearInterval(timerId);
                navigate('/din-test');
            }
        }, 1000);
    }
    return (_jsx("div", __assign({ className: 'flex justify-center items-center w-full h-full' }, { children: _jsx(AnimatedButton, __assign({ onClick: onClick, duration: 3 }, { children: _jsx("span", __assign({ className: cn('text-xl text-white font-bold uppercase [text-box:trim-both_ex_alphabetic]', {
                    'text-4xl': buttonText !== 'Start',
                }) }, { children: buttonText })) })) })));
}
function AnimatedButton(_a) {
    var children = _a.children, onClick = _a.onClick, duration = _a.duration;
    var theme = useTheme();
    function colorTransform(index) {
        var colors = [
            palette.common.purple,
            palette.primary.main,
            palette.common.salmon,
        ];
        return colors[index];
    }
    function opacityTransform(index) {
        return 0.7 - 0.2 * index;
    }
    return (_jsx(AnimatedCircles, __assign({ size: 6, duration: duration, color: theme.palette.common.black, colorTransform: colorTransform, opacityTransform: opacityTransform }, { children: _jsx(Button, __assign({ onClick: onClick, className: 'rounded-full h-28 w-28 min-w-full' }, { children: children })) })));
}
